module.exports = __webpack_public_path__ + "img/file-exclamation.ce42422d.svg";